import Axios from 'axios';

const featureFlagsClient = Axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_FEATURE_FLAGS_SERVICE_HOST}/v1`,
  headers: { Accept: 'application/json' },
});

interface ShareableFlagsResponse {
  flags: readonly string[];
}

export const getShareableFlags = async (
  shareToken: string,
): Promise<readonly string[]> => {
  try {
    const { data } = await featureFlagsClient.get<ShareableFlagsResponse>(
      '/flags/shareable',
      { headers: { 'X-AUTH-TOKEN': shareToken } },
    );

    return data.flags ?? [];
  } catch {
    return [];
  }
};
